
import {mapGetters, mapMutations} from "vuex";
import filters from "@/mixins/filters";
import folders from "@/apollo/queries/folder/folders";

export default {
	mixins: [filters],
	data() {
		return {
			showAll: true
		}
	},
	computed: {
		...mapGetters({
			folders: "folders/folders/folders",
			filters: 'filters/filters/filters',
			chosen: 'filters/filters/chosen'
		}),
		isFolders() {
			return this.$route.name === 'category-mark'
		},
		isGenerations() {
			return this.chosen.folder?.length === 1
		},
		// currentAllText() {
		// 	if (this.showAll) {
		// 		if (this.isFolders) {
		// 			return 'Меньше моделей'
		// 		} else if (this.isGenerations) {
		// 			return 'Меньше поколений'
		// 		}
		// 	} else {
		// 		if (this.isFolders) {
		// 			return 'Больше моделей'
		// 		} else if (this.isGenerations) {
		// 			return 'Больше поколений'
		// 		}
		// 	}
		// },
		// showAllButton() {
		// 	if (this.isFolders) {
		// 		return this.folders?.length >= 3
		// 	} else if (this.isGenerations) {
		// 		return this.generation?.length >= 2
		// 	}
		// },
		
		showFoldersTabs() {
			return this.folders.length && this.$route.name === 'category-mark'
		},
		showGenerations() {
      		return this.$route.params.model && !this.$route.params.car;
    	},
		currentFolder() {
      		return this.folders?.find(item => item.slug === this.$route.params.model);
    	},
		generations() {
			if(this.currentFolder?.generations){
			let generation = [...this.currentFolder.generations];
			generation.sort((a, b) => parseFloat(b.offers_count) - parseFloat(a.offers_count))
			return generation || []
			}
			else{
				return null
			}
    	}
	},
	methods: {
		...mapMutations({
			setFilterClick: 'filters/filters/SET_IS_FILTER_CLICK'
		}),
		async onToggleAll() {
			await setTimeout(function () {
				// window.scrollTo(0, -100);
			}, 1);
			this.showAll = !this.showAll
		},
	}
}
